import { useGlobalAPIQueryContext } from "@dev2_techwalnut/tw-api-query-hook";
import { useAPIQuery } from "../../../hooks/useAPIQuery";
import moment from "moment";
import { useEffect, useState } from "react";
import { FormProvider, useFieldArray, useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";
import Swal from "sweetalert2";
import { isQuantityFilled } from "../../utils/trim-decimal";

const IssueSlipUpdated = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const privileges = secureLocalStorage.getItem("privileges");
    const userID = secureLocalStorage.getItem("userID");

    const { invalidateApi } = useGlobalAPIQueryContext();

    const requisitionInfo = location.state?.data;
    console.log(requisitionInfo);
    const { action, date, machine } = location.state;

    const methods = useForm({
        mode: "onBlur",
    });

    const { register, handleSubmit, reset, control } = methods;

    const { fields: slips } = useFieldArray({
        control,
        name: `slips`,
    });

    // Sorting state
    const [sortConfig, setSortConfig] = useState({
        key: null,
        direction: null,
    });

    const {
        useFetch: useFetchRequisitionSlips,
        useCreate: useUpdateRequisitionSlips,
    } = useAPIQuery({
        key: `requisition-slip-${requisitionInfo?.id}`,
        endpoint: "/api/requisitions/",
    });
    const {
        data: requisitionSlips,
        isLoading: requisitionSlipsLoading,
        isError: errorLoadingRequisitionSlips,
        isFetching: fetchingRequisitionSlips,
    } = useFetchRequisitionSlips({
        params: {
            c:
                action === "issue_slip_for_date" || "issue_slip_for_machine"
                    ? ""
                    : "daily_plan_id",
            q:
                action === "issue_slip_for_date" || "issue_slip_for_machine"
                    ? ""
                    : requisitionInfo?.id,
            action:
                action === "issue_slip_for_date"
                    ? "date_wise_slip"
                    : action === "issue_slip_for_machine"
                    ? "machine_wise_slip"
                    : "daily_plan_wise_slip",

            date: date,
            machine_id: machine,
            daily_plan_id: location.state?.data?.id,
        },
        abortOnNewRequest: true,
        retry: 3,
    });

    const { mutate: updateRequisitionSlips, isPending } =
        useUpdateRequisitionSlips({
            params: {
                action: "approval",
                department: "daily_plan",
            },
            errorMessageFromServer: true,
            onSuccess: (res) => {
                Swal.fire({
                    icon: "success",
                    title: "Success",
                    text: res?.message,
                }).then(() => {
                    invalidateApi({ key: "api/batch" });
                    navigate(-1);
                });
                reset();
            },
        });

    const onSubmit = (data) => {
        console.log(data);
        let res = [];
        if (privileges.includes("requesting_dept_slip_update")) {
            res = data?.slips?.map((d) => ({
                id: Number(d?.id),
                approved_by_requesting_department:
                    d?.approved_by_requesting_department ? 1 : 2,
            }));
        }
        if (res?.length > 0) {
            console.log(res);
            updateRequisitionSlips({
                data: {
                    bulk_upload: res,
                    updated_by: userID,
                },
            });
        } else {
            Swal.fire({
                icon: "warning",
                title: "No data to update",
                text: `It seems there is no data to update`,
            });
        }
    };

    useEffect(() => {
        if (requisitionSlips) {
            reset({
                slips: requisitionSlips?.results?.data?.map((rs) => ({
                    id: rs?.id,
                    item_id: rs?.item?.id,
                    item_name: rs?.item?.item_name,
                    daily_plan_code: rs?.daily_plan?.daily_plan_code,
                    requisition_code: rs?.requisition_code,
                    requested_quantity: rs?.requested_quantity,
                    received_quantity: rs?.received_quantity,
                    stock_quantity: rs?.item?.stock_quantity,
                    approved_by_allotting_department:
                        rs?.approved_by_allotting_department === 1
                            ? true
                            : false,
                    approved_by_requesting_department:
                        rs?.approved_by_requesting_department === 1
                            ? true
                            : false,
                    uom: rs?.item?.uom,
                    batches: [],
                    category: rs?.item?.category,
                    machine: rs?.machine || "-",
                })),
            });
        }
    }, [requisitionSlips]);

    // Sorting function
    const handleSort = (key) => {
        let direction = "asc";
        if (sortConfig.key === key && sortConfig.direction === "asc") {
            direction = "desc";
        }
        setSortConfig({ key, direction });
    };

    // Get sorted slips
    const getSortedSlips = () => {
        if (!slips || slips.length === 0) return [];

        const sortedSlips = [...slips];

        if (sortConfig.key) {
            sortedSlips.sort((a, b) => {
                let aValue = a[sortConfig.key];
                let bValue = b[sortConfig.key];

                // Handle null/undefined values
                if (aValue == null) aValue = "";
                if (bValue == null) bValue = "";

                // Convert to string for comparison
                aValue = String(aValue).toLowerCase();
                bValue = String(bValue).toLowerCase();

                if (aValue < bValue) {
                    return sortConfig.direction === "asc" ? -1 : 1;
                }
                if (aValue > bValue) {
                    return sortConfig.direction === "asc" ? 1 : -1;
                }
                return 0;
            });
        }

        return sortedSlips;
    };

    const sortedSlips = getSortedSlips();

    // Sort icon component
    const SortIcon = ({ columnKey }) => {
        if (sortConfig.key !== columnKey) {
            return <span style={{ marginLeft: "5px", opacity: 0.3 }}>↕</span>;
        }
        return (
            <span style={{ marginLeft: "5px" }}>
                {sortConfig.direction === "asc" ? "↑" : "↓"}
            </span>
        );
    };

    console.log(slips);

    return (
        <>
            <div className="nk-block-head nk-block-head-sm">
                <div className="nk-block-between">
                    <div className="nk-block-head-content d-flex">
                        <h3 className="nk-block-title page-title">
                            Issue Slip
                        </h3>
                    </div>
                </div>
            </div>
            <div className="card">
                <FormProvider {...methods}>
                    <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
                        <div className="card-inner p-0 m-0">
                            <div className="card-body table-responsive p-0 pb-0">
                                <table className="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th
                                                colSpan={11}
                                                className="text-center"
                                            >
                                                Green Edge Venture
                                            </th>
                                        </tr>
                                        <tr>
                                            <th
                                                colSpan={11}
                                                className="text-center"
                                            >
                                                Issue slip
                                            </th>
                                        </tr>
                                        <tr>
                                            <th
                                                colSpan={11}
                                                className="text-end"
                                            >
                                                Date:{" "}
                                                {moment(
                                                    requisitionInfo?.date
                                                ).format("DD-MM-YYYY")}
                                            </th>
                                        </tr>
                                        <tr>
                                            <th
                                                colSpan={8}
                                                className="text-center"
                                            >
                                                Requesting departmnent
                                            </th>
                                        </tr>
                                        <tr>
                                            <th
                                                className="text-center"
                                                onClick={() =>
                                                    handleSort("item_name")
                                                }
                                                style={{
                                                    cursor: "pointer",
                                                    userSelect: "none",
                                                }}
                                            >
                                                Material
                                                <SortIcon columnKey="item_name" />
                                            </th>
                                            {/* <th
                                                className="text-center"
                                                onClick={() =>
                                                    handleSort("machine")
                                                }
                                                style={{
                                                    cursor: "pointer",
                                                    userSelect: "none",
                                                }}
                                            >
                                                Machine
                                                <SortIcon columnKey="machine" />
                                            </th> */}
                                            <th className="text-center">
                                                Requisition No
                                            </th>
                                            <th className="text-center">
                                                Batch No
                                            </th>
                                            <th className="text-center">
                                                Req. Qty
                                            </th>
                                            <th className="text-center">
                                                Total issued quantity
                                            </th>
                                            <th className="text-center">
                                                Issued
                                            </th>
                                            <th className="text-center">
                                                Approve
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {sortedSlips?.length > 0 &&
                                        !errorLoadingRequisitionSlips ? (
                                            sortedSlips?.map((slip, index) => {
                                                // Find original index for form registration
                                                const originalIndex =
                                                    slips.findIndex(
                                                        (s) => s.id === slip.id
                                                    );
                                                const isIssued =
                                                    Boolean(
                                                        slip?.approved_by_allotting_department
                                                    ) ||
                                                    isQuantityFilled(
                                                        slip?.received_quantity,
                                                        slip?.requested_quantity
                                                    );
                                                return (
                                                    <tr key={index}>
                                                        <td className="text-center">
                                                            {slip?.item_name}
                                                        </td>
                                                        {/* <td className="text-center">
                                                            {slip?.machine ||
                                                                "-"}
                                                        </td> */}
                                                        <td className="text-center">
                                                            {
                                                                slip?.requisition_code
                                                            }
                                                        </td>
                                                        <td className="text-center">
                                                            {
                                                                slip?.daily_plan_code
                                                            }
                                                        </td>
                                                        <td className="text-center">
                                                            {
                                                                slip?.requested_quantity
                                                            }
                                                        </td>
                                                        <td className="text-center">
                                                            <span className="fs-8 text-info">
                                                                {
                                                                    slip?.received_quantity
                                                                }
                                                            </span>
                                                        </td>
                                                        <td className="text-center">
                                                            {isIssued ? (
                                                                <span className="text-success">
                                                                    Issued
                                                                </span>
                                                            ) : (
                                                                <span className="text-danger">
                                                                    Not Issued
                                                                </span>
                                                            )}
                                                        </td>
                                                        <td className="text-center">
                                                            <span
                                                                className="text-success"
                                                                style={{
                                                                    display:
                                                                        slip?.approved_by_requesting_department
                                                                            ? "block"
                                                                            : "none",
                                                                }}
                                                            >
                                                                Approved
                                                            </span>
                                                            <input
                                                                type="checkbox"
                                                                {...register(
                                                                    `slips.${originalIndex}.approved_by_requesting_department`
                                                                )}
                                                                disabled={(() => {
                                                                    // If allotting department has NOT approved → disable
                                                                    if (
                                                                        !isIssued
                                                                    ) {
                                                                        return true;
                                                                    }

                                                                    return false;
                                                                })()}
                                                                style={{
                                                                    display:
                                                                        slip?.approved_by_requesting_department
                                                                            ? "none"
                                                                            : "block",
                                                                }}
                                                            />
                                                        </td>
                                                    </tr>
                                                );
                                            })
                                        ) : !(
                                              requisitionSlipsLoading ||
                                              fetchingRequisitionSlips
                                          ) ? (
                                            <tr>
                                                <td
                                                    colSpan={8}
                                                    className="text-center"
                                                >
                                                    {errorLoadingRequisitionSlips
                                                        ? "Error loading data"
                                                        : "No data to display"}
                                                </td>
                                            </tr>
                                        ) : null}
                                        {(requisitionSlipsLoading ||
                                            fetchingRequisitionSlips) && (
                                            <tr>
                                                <td
                                                    colSpan={9}
                                                    className="text-center"
                                                >
                                                    Loading data...
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                            <div className="col-12 m-3 ">
                                <div className="form-group">
                                    <button
                                        type="button"
                                        className="btn btn-md btn-light me-2"
                                        id="submit-button-backbutton"
                                        onClick={() => navigate(-1)}
                                    >
                                        Back
                                    </button>
                                    {isPending ? (
                                        <button
                                            type="button"
                                            id="button-typemaster-loading"
                                            className="btn btn-md text-dark"
                                            disabled
                                        >
                                            Loading...
                                        </button>
                                    ) : (
                                        <button
                                            type="submit"
                                            className="btn btn-md btn-primary"
                                            id="submit-button-create-typemaster"
                                            disabled={
                                                requisitionSlipsLoading ||
                                                errorLoadingRequisitionSlips ||
                                                requisitionSlips?.results?.data
                                                    ?.length === 0
                                            }
                                        >
                                            Submit
                                        </button>
                                    )}
                                </div>
                            </div>
                        </div>
                    </form>
                </FormProvider>
            </div>
        </>
    );
};

export default IssueSlipUpdated;
